<template>
    <div class="d-flex flex-column">
        <v-select :items="separators" label="Choix du séparateur" v-model="selectedSeparator">
            <template v-slot:item="{ active, item, attrs, on }">
                <v-list-item v-on="on" v-bind="attrs" @click.stop>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ item }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-select>
        <v-checkbox v-model="displayHeaders" label="Ajouter les titres des colonnes en en-tête"></v-checkbox>
        <v-combobox v-model="selectedColumns" :items="headers[0]" label="Choix des colonnes" multiple chips
            deletable-chips>
            <template v-slot:item="{ active, item, attrs, on }">
                <v-list-item v-on="on" v-bind="attrs" #default="{ active }" @click.stop>
                    <v-list-item-action>
                        <v-checkbox :input-value="active"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ item }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
            <template v-slot:selection="{ item, index }">
                <v-chip text-color="white" color="primary" close @click:close="removeItem(index)">{{ item }}</v-chip>
            </template>
        </v-combobox>
        <p class="align-self-start mt-5 text-danger">{{ warningMessage }}</p>
        <div class="mt-5 d-flex justify-space-between">
            <button type="button" class="btn btn--plain btn--primary btn-xs" @click="$emit('modal-closed')">
                Annuler
                <v-icon dark>mdi-close</v-icon>
            </button>
            <button type="button" class="btn btn--plain btn--primary btn-xs" @click="exportFile()">
                Exporter
                <v-icon dark>mdi-download</v-icon>
            </button>
        </div>
    </div>
</template>

<script>
import ConceptsStore from "../../concepts-store";
export default {
    name: "MappingExport",

    props: {
        headers: {
            type: Array,
            default: () => []
        },

        items: {
            type: Array,
            default: () => []
        },
        isUserConnected: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            store: ConceptsStore.state,
            separators: ["|", ";", ","],
            selectedSeparator: "|",
            displayHeaders: true,
            selectedColumns: JSON.parse(JSON.stringify(this.headers[0]))
        }
    },

    computed: {
        notation() {
            let other = this.store.conceptDetail["other"];
            let notation = other.filter((el) => {
                return el["key"] == "http://www.w3.org/2004/02/skos/core#notation";
            })[0];
            return notation["value"][0];
        },
        warningMessage() {
            return this.selectedColumns.length <= 0 ? "Au moins une colonne doit être selectionnée pour pouvoir exporter" : "";
        }
    },

    methods: {
        removeItem(index) {
            this.selectedColumns.splice(index, 1);
        },

        convertToCSV(objArray) {
            var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;

            let fileString = '';

            for (let i = 0; i < array.length; i++) {
                let line = '';
                for (let j in array[i]) {
                    if (line != '') {
                        line += this.selectedSeparator;
                    }
                    if (array[i][j] == null) {
                        array[i][j] = '';
                    }
                    line += array[i][j]
                }

                //add separator at the end in case the last headers were null
                for (let n = 0; n < array[0].length - Object.keys(array[i]).length; n++) {
                    line += this.selectedSeparator;
                }

                fileString += line + '\r\n';
            }

            return fileString;
        },

        exportFile() {
            //check if at least one column is selected
            if (this.warningMessage) {
                return;
            }

            //removing the protected mappings
            let itemsToExport = this.items.filter((item) => {
                return !(!this.isUserConnected && item.isProtected);
            });

            //filling the list of values of the columns which have been selected
            let selectedKeys = [];
            let headersInOrder = []; //to keep the correct order of the headers
            for (let i in this.headers[0]) {
                if (this.selectedColumns.includes(this.headers[0][i])) {
                    selectedKeys.push(this.headers[1][i]);
                    headersInOrder.push(this.headers[0][i]);
                }
            }
            //removing the unselected columns 
            itemsToExport = itemsToExport.map((item) => {
                return selectedKeys.reduce((acc, key) => {
                    return { ...acc, [key]: item[key] };
                }, {});
            });

            if (this.displayHeaders) {
                itemsToExport.unshift(headersInOrder);
            }

            let jsonObj = JSON.stringify(itemsToExport);
            let csv = this.convertToCSV(jsonObj);
            let filename = this.store.terminologyId + '_' + this.notation + '_' + this.$route.query.lang + '.csv';
            // Ajout de '\ufeff' pour encoder les caractères spéciaux
            let blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep label {
    margin: 0;
}
</style>